
import Constructor from '~/components/catalog/constructor';

export default {
  name: 'BlogArticleSection',
  components: {Constructor},
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    titleCenter: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Array,
      required: true,
    },
  },
}
